export const createAddress = /* GraphQL */ `
  mutation CreateAddress($input: CreateAddressInput!) {
    createAddress(input: $input) {
      id
    }
  }
`;
export const updateAddress = /* GraphQL */ `
  mutation UpdateAddress($input: UpdateAddressInput!) {
    updateAddress(input: $input) {
      id
    }
  }
`;
export const assignPlatformUserRole = /* GraphQL */ `
  mutation AssignPlatformUserRole($input: AssignUserToRoleInput!) {
    assignPlatformUserRole(input: $input) {
      role
    }
  }
`;
export const createPlatformUser = /* GraphQL */ `
  mutation CreatePlatformUser($input: CreatePlatformUserInput!) {
    createPlatformUser(input: $input) {
      id
    }
  }
`;
export const updatePlatformUser = /* GraphQL */ `
  mutation UpdatePlatformUser($input: UpdatePlatformUserInput!) {
    updatePlatformUser(input: $input) {
      id
    }
  }
`;
export const deletePlatformUser = /* GraphQL */ `
  mutation DeletePlatformUser($id: ID!) {
    deletePlatformUser(id: $id) {
      id
    }
  }
`;
export const resendInvite = /* GraphQL */ `
  mutation ResendInvite($id: ID!) {
    resendInvite(id: $id) {
      id
    }
  }
`;
export const createRiskManagementProgram = /* GraphQL */ `
  mutation CreateRiskManagementProgram($input: CreateRiskManagementProgramInput!) {
    createRiskManagementProgram(input: $input) {
      id
    }
  }
`;
export const createCompanyProfile = /* GraphQL */ `
  mutation CreateCompanyProfile($input: CreateCompanyProfileInput) {
    createCompanyProfile(input: $input) {
      id
    }
  }
`;
export const createEngineerCompanyProfile = /* GraphQL */ `
  mutation CreateEngineerCompanyProfile($input: CreateEngineerCompanyProfileInput) {
    createEngineerCompanyProfile(input: $input) {
      id
    }
  }
`;
export const updateCompanyProfile = /* GraphQL */ `
  mutation UpdateCompanyProfile($input: UpdateCompanyProfileInput) {
    updateCompanyProfile(input: $input) {
      id
    }
  }
`;
export const deleteCompanyProfile = /* GraphQL */ `
  mutation DeleteCompanyProfile($id: ID!) {
    deleteCompanyProfile(id: $id) {
      id
    }
  }
`;
export const createLocation = /* GraphQL */ `
  mutation CreateLocation($input: CreateLocationInput) {
    createLocation(input: $input) {
      id
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation($input: UpdateLocationInput) {
    updateLocation(input: $input) {
      id
    }
  }
`;
export const createSurvey = /* GraphQL */ `
  mutation CreateSurvey($input: CreateSurveyInput) {
    createSurvey(input: $input) {
      id
    }
  }
`;
export const updateSurvey = /* GraphQL */ `
  mutation UpdateSurvey($input: UpdateSurveyInput) {
    updateSurvey(input: $input) {
      id
    }
  }
`;
export const deleteSurvey = /* GraphQL */ `
  mutation DeleteSurvey($id: ID!) {
    deleteSurvey(id: $id) {
      id
    }
  }
`;
export const createDocument = /* GraphQL */ `
  mutation CreateDocument($input: CreateDocumentInput!) {
    createDocument(input: $input) {
      id
    }
  }
`;
export const updateDocument = /* GraphQL */ `
  mutation UpdateDocument($input: UpdateDocumentInput!) {
    updateDocument(input: $input) {
      id
    }
  }
`;
export const deleteDocument = /* GraphQL */ `
  mutation DeleteDocument($id: ID!) {
    deleteDocument(id: $id) {
      id
    }
  }
`;
export const updateRisk = /* GraphQL */ `
  mutation UpdateRisk($id: ID!) {
    updateRisk(id: $id)
  }
`;
export const deleteRecommendation = /* GraphQL */ `
  mutation DeleteRecommendation($id: ID!) {
    deleteRecommendation(id: $id) {
      id
    }
  }
`;
export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      id
    }
  }
`;
export const createAccount = /* GraphQL */ `
  mutation CreateAccount($input: CreateAccountInput!) {
    createAccount(input: $input) {
      id
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount($id: ID!) {
    deleteAccount(id: $id) {
      id
    }
  }
`;
export const createSector = /* GraphQL */ `
  mutation CreateSector($input: CreateSectorInput) {
    createSector(input: $input) {
      id
      name
    }
  }
`;
export const updateSector = /* GraphQL */ `
  mutation UpdateSector($input: UpdateSectorInput) {
    updateSector(input: $input) {
      id
      name
    }
  }
`;
export const deleteSector = /* GraphQL */ `
  mutation DeleteSector($id: ID!) {
    deleteSector(id: $id) {
      id
    }
  }
`;
export const updateRecommendation = /* GraphQL */ `
  mutation UpdateRecommendation($input: UpdateRecommendationInput) {
    updateRecommendation(input: $input) {
      id
    }
  }
`;
export const createRecommendation = /* GraphQL */ `
  mutation CreateRecommendation($input: CreateRecommendationInput) {
    createRecommendation(input: $input) {
      id
    }
  }
`;
export const updateCope = /* GraphQL */ `
  mutation UpdateCope($input: UpdateCopeInput) {
    updateCope(input: $input) {
      id
    }
  }
`;
export const createCope = /* GraphQL */ `
  mutation CreateCope($input: CreateCopeInput) {
    createCope(input: $input) {
      id
    }
  }
`;
export const deleteCope = /* GraphQL */ `
  mutation DeleteCope($id: ID!) {
    deleteCope(id: $id) {
      id
    }
  }
`;
export const createLossEstimate = /* GraphQL */ `
  mutation CreateLossEstimate($input: CreateLossEstimateInput) {
    createLossEstimate(input: $input) {
      id
    }
  }
`;
export const updateLossEstimate = /* GraphQL */ `
  mutation UpdateLossEstimate($input: UpdateLossEstimateInput) {
    updateLossEstimate(input: $input) {
      id
    }
  }
`;
export const deleteLossEstimate = /* GraphQL */ `
  mutation DeleteLossEstimate($id: ID!) {
    deleteLossEstimate(id: $id) {
      id
    }
  }
`;
export const updateAgency = /* GraphQL */ `
  mutation UpdateAgency($input: UpdateAgencyInput) {
    updateAgency(input: $input) {
      id
    }
  }
`;
export const createAgency = /* GraphQL */ `
  mutation CreateAgency($input: CreateAgencyInput) {
    createAgency(input: $input) {
      id
    }
  }
`;
export const deleteAgency = /* GraphQL */ `
  mutation DeleteAgency($id: ID!) {
    deleteAgency(id: $id) {
      id
    }
  }
`;
export const updateClassification = /* GraphQL */ `
  mutation UpdateClassification($input: UpdateClassificationInput) {
    updateClassification(input: $input) {
      id
    }
  }
`;
export const createClassification = /* GraphQL */ `
  mutation CreateClassification($input: CreateClassificationInput) {
    createClassification(input: $input) {
      id
    }
  }
`;
export const deleteClassification = /* GraphQL */ `
  mutation DeleteClassification($id: ID!) {
    deleteClassification(id: $id) {
      id
    }
  }
`;
export const deleteContact = /* GraphQL */ `
  mutation DeleteContact($id: ID!) {
    deleteContact(id: $id) {
      id
    }
  }
`;
export const createContact = /* GraphQL */ `
  mutation CreateContact($input: CreateContactInput) {
    createContact(input: $input) {
      id
      name
      job_title
      email
      phone
    }
  }
`;
export const updateContact = /* GraphQL */ `
  mutation UpdateContact($input: UpdateContactInput) {
    updateContact(input: $input) {
      id
      name
      job_title
      email
      phone
    }
  }
`;
export const createRecommendationsReport = /* GraphQL */ `
  mutation CreateRecommendationsReport($report: String, $template: String, $q: StandardQueryWithCompanyOptional) {
    createRecommendationsReport(report: $report, template: $template, q: $q)
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation($id: ID!) {
    deleteLocation(id: $id) {
      id
    }
  }
`;
export const assignContactsLocation = /* GraphQL */ `
  mutation AssignContactsLocation($input: AssignContactsToLocationInput!) {
    assignContactsLocation(input: $input)
  }
`;
export const assignLocationsContact = /* GraphQL */ `
  mutation AssignLocationsContact($input: AssignLocationsToContactInput!) {
    assignLocationsContact(input: $input)
    q
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage($input: CreateMessageInput!) {
    createMessage(input: $input) {
      id
    }
  }
`;
export const removeCompaniesFromAccount = /* GraphQL */ `
  mutation RemoveCompaniesFromAccount($input: RemoveCompaniesFromAccountInput!) {
    removeCompaniesFromAccount(input: $input)
  }
`;
export const assignLocation = /* GraphQL */ `
  mutation assignLocation($input: AssignLocationInput!) {
    assignLocation(input: $input)
  }
`;
export const assignLocationsToUser = /* GraphQL */ `
  mutation assignLocationsToUser($input: AssignLocationsToUserInput!) {
    assignLocationsToUser(input: $input) {
      id
    }
  }
`;
export const assignUsersToLocation = /* GraphQL */ `
  mutation assignUsersToLocation($input: AssignUsersToLocationInput!) {
    assignUsersToLocation(input: $input) {
      id
    }
  }
`;
export const unassignLocationsFromUser = /* GraphQL */ `
  mutation unassignLocationsFromUser($input: UnassignLocationsFromUserInput!) {
    unassignLocationsFromUser(input: $input) {
      id
    }
  }
`;
export const unassignUsersFromLocation = /* GraphQL */ `
  mutation unassignUsersFromLocation($input: UnassignUsersFromLocationInput!) {
    unassignUsersFromLocation(input: $input) {
      id
    }
  }
`;
export const assignCompaniesToAccount = /* GraphQL */ `
  mutation AssignCompaniesToAccount($input: AssignCompaniesToAccountInput!) {
    assignCompaniesToAccount(input: $input)
  }
`;
export const assignMasterRiskManagementProgramForBatch = `
  assignMasterRiskManagementProgram($arg) {
    id
  }
`;
export const batchAssignRiskModelMasterRiskParameter = `
  assignRiskModelMasterRiskParameter($arg)
`;
export const batchUpdateMasterRiskControls = `
    updateMasterRiskControl($arg) {
      id
    }
`;
export const batchCreateMasterRiskControls = `
    createMasterRiskControl($arg) {
      id
    }
`;
export const updateInsuranceProduct = /* GraphQL */ `
  mutation UpdateInsuranceProduct($input: UpdateInsuranceProductInput) {
    updateInsuranceProduct(input: $input) {
      id
    }
  }
`;
export const createInsuranceProduct = /* GraphQL */ `
  mutation CreateInsuranceProduct($input: CreateInsuranceProductInput) {
    createInsuranceProduct(input: $input) {
      id
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct($id: ID!) {
    deleteInsuranceProduct(id: $id) {
      id
    }
  }
`;
export const createMasterActivityTemplate = /* GraphQL */ `
  mutation CreateMasterActivityTemplate($input: CreateMasterActivityTemplateInput) {
    createMasterActivityTemplate(input: $input) {
      id
      latest_version {
        id
      }
    }
  }
`;
export const updateMasterActivityTemplate = /* GraphQL */ `
  mutation UpdateMasterActivityTemplate($input: UpdateMasterActivityTemplateInput) {
    updateMasterActivityTemplate(input: $input) {
      id
    }
  }
`;
// export const createMasterActivityTemplateMapping = /* GraphQL */ `
//   createMasterActivityTemplateMapping($arg) {
//     id
//   }
// `;
// export const updateMasterActivityTemplateMapping = /* GraphQL */ `
//   updateMasterActivityTemplateMapping($arg) {
//     id
//   }
// `;
export const createMasterActivityTemplateMapping = /* GraphQL */ `
  mutation CreateMasterActivityTemplateMapping($input: CreateMasterActivityTemplateMappingInput) {
    createMasterActivityTemplateMapping(input: $input) {
      id
    }
  }
`;
export const updateMasterActivityTemplateMapping = /* GraphQL */ `
  mutation UpdateMasterActivityTemplateMapping($input: UpdateMasterActivityTemplateMappingInput) {
    updateMasterActivityTemplateMapping(input: $input) {
      id
    }
  }
`;
export const createMasterRiskCategory = /* GraphQL */ `
  mutation CreateMasterRiskCategory($input: CreateMasterRiskCategoryInput) {
    createMasterRiskCategory(input: $input) {
      id
    }
  }
`;
export const updateMasterRiskCategory = /* GraphQL */ `
  mutation UpdateMasterRiskCategory($input: UpdateMasterRiskCategoryInput) {
    updateMasterRiskCategory(input: $input) {
      id
    }
  }
`;
export const deleteMasterRiskCategory = /* GraphQL */ `
  mutation DeleteMasterRiskCategory($id: ID!) {
    deleteMasterRiskCategory(id: $id) {
      id
    }
  }
`;
export const deleteMasterRiskManagementProgram = /* GraphQL */ `
  mutation DeleteMasterRiskManagementProgram($id: ID!, $recursive: Boolean) {
    deleteMasterRiskManagementProgram(id: $id, recursive: $recursive) {
      id
    }
  }
`;
export const createMasterRiskManagementProgram = /* GraphQL */ `
  mutation CreateMasterRiskManagementProgram($input: CreateMasterRiskManagementProgramInput!) {
    createMasterRiskManagementProgram(input: $input) {
      id
    }
  }
`;
export const updateMasterRiskManagementProgram = /* GraphQL */ `
  mutation UpdateMasterRiskManagementProgram($input: UpdateMasterRiskManagementProgramInput!) {
    updateMasterRiskManagementProgram(input: $input) {
      id
    }
  }
`;
export const assignMasterRiskManagementProgram = /* GraphQL */ `
  mutation AssignMasterRiskManagementProgram($input: AssignMasterRiskManagementProgramInput!) {
    assignMasterRiskManagementProgram(input: $input) {
      id
    }
  }
`;
export const deleteMasterActivityTemplateMapping = `
  deleteMasterActivityTemplateMapping($arg) {
    id
  }
`;
export const createMasterRiskParameter = /* GraphQL */ `
  mutation CreateMasterRiskParameter($input: CreateMasterRiskParameterInput) {
    createMasterRiskParameter(input: $input) {
      id
    }
  }
`;
export const updateMasterRiskParameter = /* GraphQL */ `
  mutation UpdateMasterRiskParameter($input: UpdateMasterRiskParameterInput) {
    updateMasterRiskParameter(input: $input) {
      id
    }
  }
`;
export const deleteMasterRiskParameter = /* GraphQL */ `
  mutation DeleteMasterRiskParameter($id: ID!) {
    deleteMasterRiskParameter(id: $id) {
      id
    }
  }
`;
export const createRiskModel = /* GraphQL */ `
  mutation CreateRiskModel($input: CreateRiskModelInput) {
    createRiskModel(input: $input) {
      id
    }
  }
`;
export const updateRiskModel = /* GraphQL */ `
  mutation UpdateRiskModel($input: UpdateRiskModelInput) {
    updateRiskModel(input: $input) {
      id
    }
  }
`;
export const assignRiskModelMasterRiskParameter = /* GraphQL */ `
  mutation AssignRiskModelMasterRiskParameter($input: AssignRiskModelMasterRiskParameterInput) {
    assignRiskModelMasterRiskParameter(input: $input)
  }
`;
export const deleteActivity = /* GraphQL */ `
  mutation DeleteActivity($id: [ID]!) {
    deleteActivity(id: $id) {
      id
    }
  }
`;
export const deleteMasterActivityTemplate = /* GraphQL */ `
  mutation DeleteMasterActivityTemplate($id: ID!) {
    deleteMasterActivityTemplate(id: $id) {
      id
    }
  }
`;
export const scheduleActivities = /* GraphQL */ `
  mutation ScheduleActivities($input: ScheduleActivitiesInput) {
    scheduleActivities(input: $input) {
      id
    }
  }
`;
export const approveActivity = /* GraphQL */ `
  mutation ApproveActivity($input: ApproveActivityInput) {
    approveActivity(input: $input) {
      id
    }
  }
`;
export const updateAssociatedMasterRMP = /* GraphQL */ `
  mutation UpdateAssociatedMasterRMP($input: UpdateAssociatedMasterRMPInput!) {
    updateAssociatedMasterRMP(input: $input) {
      id
    }
  }
`;
export const batchDeleteMasterRiskControls = /* GraphQL */ `
  deleteMasterRiskControl($arg) {
    id
  }
`;
export const deleteMasterRiskControl = /* GraphQL */ `
  mutation DeleteMasterRiskControl($id: ID!) {
    deleteMasterRiskControl(id: $id) {
      id
    }
  }
`;
export const batchDeleteScheduledActivities = /* GraphQL */ `
  deleteScheduledActivities($arg) {
    id
  }
`;
export const deleteScheduledActivities = /* GraphQL */ `
  mutation DeleteScheduledActivities($master_activity_template: ID!, $company_profile: ID!, $locations: [ID]) {
    deleteScheduledActivities(master_activity_template: $master_activity_template, company_profile: $company_profile, locations: $locations) {
      id
    }
  }
`;
export const updateParamStateMappings = /* GraphQL */ `
  mutation UpdateParamStateMappings($input: UpdateParamStateMappingInput) {
    updateParamStateMappings(input: $input) {
      value
    }
  }
`;
export const batchDeleteMasterActivityTemplates = `
  deleteMasterActivityTemplate($arg) {
    id
  }
`;
export const assignRiskModelMasterRiskParameters = /* GraphQL */ `
  mutation AssignRiskModelMasterRiskParameters($input: AssignRiskModelMasterRiskParametersInput!) {
    assignRiskModelMasterRiskParameters(input: $input)
  }
`;
export const updateRiskModelMasterRiskParameters = /* GraphQL */ `
  mutation UpdateRiskModelMasterRiskParameters($input: UpdateRiskModelMasterRiskParametersInput!) {
    updateRiskModelMasterRiskParameters(input: $input)
  }
`;
export const removeRiskModelMasterRiskParameters = /* GraphQL */ `
  mutation RemoveRiskModelMasterRiskParameters($input: RemoveRiskModelMasterRiskParametersInput!) {
    removeRiskModelMasterRiskParameters(input: $input)
  }
`;
export const updateRiskProfile = /* GraphQL */ `
  mutation UpdateRiskProfile($input: UpdateRiskProfileInput) {
    updateRiskProfile(input: $input) {
      id
      profile_completion
      risk_categories {
        id
        name
        description
        sum_controls
        sum_parameters
        risk_parameters {
          id
          name
          risk_controls {
            id
            name
            state {
              id
              state
              updated
            }
            possible_states {
              state
              id
            }
          }
        }
      }
    }
  }
`;
export const copyMasterActivityTemplate = /* GraphQL */ `
  mutation CopyMasterActivityTemplate($id: ID!) {
    copyMasterActivityTemplate(id: $id) {
      id
    }
  }
`;
export const copyMasterRiskManagementProgram = /* GraphQL */ `
  mutation CopyMasterRiskManagementProgram($id: ID!) {
    copyMasterRiskManagementProgram(id: $id) {
      id
    }
  }
`;
export const createPolicy = /* GraphQL */ `
  mutation CreatePolicy($input: CreatePolicyInput!) {
    createPolicy(input: $input) {
      id
    }
  }
`;
export const updatePolicy = /* GraphQL */ `
  mutation UpdatePolicy($input: UpdatePolicyInput!) {
    updatePolicy(input: $input) {
      id
    }
  }
`;
export const deletePolicy = /* GraphQL */ `
  mutation DeletePolicy($id: ID!) {
    deletePolicy(id: $id) {
      id
    }
  }
`;
export const updateSmartSchedulerSimulation = /* GraphQL */ `
  mutation UpdateSmartSchedulerSimulation($input: SmartSchedulerSimulationInput) {
    updateSmartSchedulerSimulation(input: $input)
  }
`;
export const updateActivity = /* GraphQL */ `
  mutation UpdateActivity($input: UpdateActivityInput!) {
    updateActivity(input: $input) {
      id
    }
  }
`;
export const createIssue = /* GraphQL */ `
  mutation CreateIssue($input: CreateIssueInput!) {
    createIssue(input: $input) {
      id
    }
  }
`;
export const updateIssue = /* GraphQL */ `
  mutation UpdateIssue($input: UpdateIssueInput!) {
    updateIssue(input: $input) {
      id
    }
  }
`;
export const deleteIssue = /* GraphQL */ `
  mutation DeleteIssue($id: ID!) {
    deleteIssue(id: $id) {
      id
    }
  }
`;
export const createMasterControlState = /* GraphQL */ `
  mutation CreateMasterControlState($input: CreateMasterControlStateInput!) {
    createMasterControlState(input: $input) {
      id
    }
  }
`;
export const updateMasterControlState = /* GraphQL */ `
  mutation UpdateMasterControlState($input: UpdateMasterControlStateInput!) {
    updateMasterControlState(input: $input) {
      id
    }
  }
`;
export const deleteMasterControlState = /* GraphQL */ `
  mutation DeleteMasterControlState($id: [ID]!) {
    deleteMasterControlState(id: $id) {
      id
    }
  }
`;
export const createMasterRiskControl = /* GraphQL */ `
  mutation CreateMasterRiskControl($input: CreateMasterRiskControlInput!) {
    createMasterRiskControl(input: $input) {
      id
    }
  }
`;
export const updateMasterRiskControl = /* GraphQL */ `
  mutation UpdateMasterRiskControl($input: UpdateMasterRiskControlInput!) {
    updateMasterRiskControl(input: $input) {
      id
    }
  }
`;
// export const deleteMasterRiskControl = /* GraphQL */ `
//   mutation DeleteMasterRiskControl($id: ID!) {
//     deleteMasterRiskControl(id: $id) {
//       id
//     }
//   }
// `;
export const updateActivityApproval = /* GraphQL */ `
  mutation UpdateActivityApproval($input: UpdateActivityApprovalInput) {
    updateActivityApproval(input: $input)
  }
`;
